import React from 'react';
import { AirportGeoGridCore } from './sections/AirportGeoGridCore';
import UnifiedGeoGridPdfV2 from '../shared/UnifiedGeoGridPdfV2';
import { GeoGridPdfProps } from '../../shared/types/PdfTypedInterfaces';

const GeoGridResultsPdfDocumentV2: React.FC<GeoGridPdfProps> = ({ dynamicProject, projectInfo, t, geoGridData, geogridImage }) => {
    return (
        <UnifiedGeoGridPdfV2
            dynamicProject={dynamicProject}
            projectInfo={projectInfo}
            t={t}
            geoGridData={geoGridData}
            geogridImage={geogridImage}
            coreComponent={AirportGeoGridCore}
            defaultProjectType="airport"
            customTitle={t('pdf_header_technical_report_groundmac') || 'GROUNDMAC - Design Technical Report'}
            customProjectType={t('project_type_airport') || 'Airport'}
            customSubtitle={t('subtitle_designing_geogrid') || 'Designing Geogrid'}
        />
    );
};

export default GeoGridResultsPdfDocumentV2;
